import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { NAVIGATION_ITEMS } from './navigation.constants'
import { environment } from '@env'
import { ProfileStore } from '@core/store/profile/profile.store'
import { RouterLink, RouterLinkActive } from '@angular/router'
import { Tooltip } from '@shared/modules/primeng-clone/tooltip'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'bo-navigation',
  templateUrl: './navigation.html',
  styleUrl: './navigation.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, Tooltip, TranslatePipe],
})
export class Navigation {
  readonly #profileStore = inject(ProfileStore)

  readonly navItems = NAVIGATION_ITEMS.filter((item) => !item.deactivated)
  readonly isProduction = environment.production
  readonly permissions = this.#profileStore.permissions
}
